import { Box, Grid } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import getAxiosError from "../../app/api/axiosError";
import { fetchFdpAssociatedClients } from "../../app/features/fdp/fdpSlice";
import { RootState, useAppDispatch } from "../../app/features/store/store";

import { FdpResponse } from "../../app/models/responseModels/loginResponse";
import { updateUserTokenToInvalid } from "../../app/features/login/loginSlice";
import Loader from "../../components/common/loader/Loader";

interface FdpGeneralDetailsProps {
  fdpSelectedRow: FdpResponse;
  setFdpSelectedRow: any;
}

const FdpHistory = ({ fdpSelectedRow }: FdpGeneralDetailsProps) => {
  return (
    <>
      <Box sx={{ width: "100%" }}>
        <p>Yet To Introduce</p>
      </Box>
      <br />
    </>
  );
};

export default FdpHistory;
